import styled from 'styled-components';
import { SaveOutlined as SaveIcon } from '@mui/icons-material';

import Select from '../../../../../../../components/Select';
import Button, { ButtonIconStyle } from '../../../../../../../components/v2/Button';

const StyledSaveIcon = styled(SaveIcon)`
  ${ButtonIconStyle}
`;

const StyledSelect = styled(Select)`
  width: 100px;
`;

const StyledButton = styled(Button)`
  margin-top: 30px;
`;

export {
  StyledSaveIcon,
  StyledSelect,
  StyledButton,
};
